import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  setProfileModalPage,
  displayProfileModal,
} from '../../../modules/profile/actions/creators'

import MapSurvey from '../components/MapSurvey/MapSurvey'

const mapStateToProps = reduxState => {
  const { profile, auth } = reduxState

  const { profileModalPage, surveyData } = profile
  const { accessToken } = auth

  return {
    profileModalPage,
    accessToken,
    surveyData,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setProfileModalPage,
      displayProfileModal,
    },
    dispatch,
  )

const ConnectedMapSurvey = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MapSurvey)

export default ConnectedMapSurvey
